import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4600Model } from '../kymw4600.model';
import { TagInfo } from '../vo/tag-info.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
type GetTagListResponse = {
  TagId: string;
  TagName: string;
}[];

/**
 * タグ一覧取得サービス
 * @export GetTagListService
 * @class GetTagListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetTagListService extends PlessJsonResponderSub<GetTagListResponse> {
  model: KYMW4600Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetTagListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetTagListService
   */
  execute(model: KYMW4600Model, f: () => void = null): void {
    this.model = model;
    this.calbak = f;
    this.send('getTagList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetTagListService
   */
  success(data: GetTagListResponse) {
    this.model.tagListOrigin = data.map(_ => new TagInfo(_.TagId, _.TagName));
    this.model.tagListForEdit = data.map(_ => new TagInfo(_.TagId, _.TagName));
    if (this.calbak) this.calbak();
  }
}
